import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Neutralise l'overlay CRA sur les erreurs cross-origin opaques ("Script error.")
// que Safari remonte quand l'app est chargée en iframe (preview Emergent).
// L'app fonctionne — l'erreur n'est qu'un artefact du dev overlay masqué par
// les restrictions CORS de Safari. Cette protection ne s'applique QU'aux
// erreurs sans source/stack : les vraies erreurs applicatives passent normalement.
if (typeof window !== "undefined") {
  const isOpaqueScriptError = (msg, src) =>
    (msg === "Script error." || msg === "Script error") && (!src || src === "");
  window.addEventListener("error", (e) => {
    if (isOpaqueScriptError(e.message, e.filename)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    if (r && typeof r === "object" && (r.message === "Script error." || r.message === "Script error")) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
